import { ChevronRight, Home } from "lucide-react";
import React from "react";

import { Button } from "@/components/ui/button";
import { NEGATIVE_ONE } from "@/constants/constants";
import { DirPath } from "@/interfaces/project-register.interface";

interface BreadcrumbProps {
  directoryPath: DirPath[];
  onNavigate: (folderId: string | null) => void;
  className?: string;
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({
  directoryPath,
  onNavigate,
  className = "",
}) => {
  const handleNavigate = (index: number): void => {
    if (index === NEGATIVE_ONE) {
      // Navigate to root
      onNavigate(null);
    } else {
      // Navigate to specific folder
      onNavigate(directoryPath[index].id);
    }
  };

  return (
    <div className={`flex items-center space-x-1 text-sm ${className}`}>
      {/* Root/Home button */}
      <Button
        variant='link'
        size='sm'
        onClick={() => handleNavigate(-1)}
        className={`h-8 px-2 hover:bg-gray-100 ${directoryPath.length === 0 ? "font-semibold text-primary" : "text-gray-800"}`}
        title='Home'
        disabled={directoryPath.length === 0}
        tabIndex={directoryPath.length === 0 ? -1 : 0}
      >
        <Home className='h-4 w-4' />
      </Button>

      {/* Directory path */}
      {directoryPath.map((dir, index) => {
        const isCurrent = index === directoryPath.length - 1;

        return (
          <React.Fragment key={dir.id}>
            <ChevronRight className='h-4 w-4 text-gray-800' />
            <Button
              variant='ghost'
              size='sm'
              onClick={() => handleNavigate(index)}
              className={`h-8 px-2 hover:bg-gray-100 max-w-[200px] truncate ${
                isCurrent ? "font-semibold text-primary" : "text-gray-800"
              }`}
              title={dir.name}
              disabled={isCurrent}
              tabIndex={isCurrent ? -1 : 0}
            >
              {dir.name}
            </Button>
          </React.Fragment>
        );
      })}
    </div>
  );
};
